var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
var CLAIMS_COMMON_ASSETS_MAP = {};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CLAIMS_COMMON_ASSETS_MAP);
};

// src/constants/claims-status-colors-map.constant.ts
var CLAIMS_STATUS_COLORS_MAP = {
  adjusted: {
    badgeColor: "info",
    bannerColor: "$highlightIcon"
  },
  approved: {
    badgeColor: "success",
    bannerColor: "$successIcon"
  },
  not_covered: {
    badgeColor: "error",
    bannerColor: "$criticalIcon"
  },
  partially_paid: {
    badgeColor: "warning",
    bannerColor: "$warningIcon"
  },
  pending: {
    badgeColor: "neutral",
    bannerColor: "$interactiveActionSubdued"
  }
};
var CLAIMS_MASONRY_STATUS_COLORS_MAP = {
  error: {
    badgeColor: "error",
    sidebarColor: "$criticalIcon"
  },
  neutral: {
    badgeColor: "neutral",
    sidebarColor: "$interactiveActionSubdued"
  },
  info: {
    badgeColor: "info",
    sidebarColor: "$highlightIcon"
  },
  success: {
    badgeColor: "success",
    sidebarColor: "$successIcon"
  },
  warning: {
    badgeColor: "warning",
    sidebarColor: "$warningIcon"
  }
};

// src/hooks/use-download-explanation-of-benefits-query.hook.ts
import { useQuery } from "react-query";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
import {
  GET_DOWNLOAD_EXPLANATION_OF_BENEFITS_PATH,
  getDownloadExplanationOfBenefits
} from "@leagueplatform/claims-api";
function useDownloadExplanationOfBenefits(userId) {
  const { claimId } = useParams();
  const variables = {
    pathParams: {
      claimId
    },
    queryParams: {
      userId
    }
  };
  return useQuery(
    [GET_DOWNLOAD_EXPLANATION_OF_BENEFITS_PATH, variables],
    () => getDownloadExplanationOfBenefits(variables),
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      onError() {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "PLAIN_SOMETHING_WENT_WRONG",
          contentId: "CLAIMS_EXPLANATION_OF_BENEFITS_DOWNLOAD_ERROR"
        });
      }
    }
  );
}

// src/hooks/use-format-claims-amount.hook.ts
import { useIntl } from "@leagueplatform/locales";
import { useCallback } from "react";
function useFormatClaimsValue() {
  const { formatMoney } = useIntl();
  return useCallback(
    (value) => {
      var _a;
      return formatMoney({
        F: ((_a = value == null ? void 0 : value.amount) != null ? _a : 0) / 100,
        C: value == null ? void 0 : value.currencyCode
      });
    },
    [formatMoney]
  );
}

// src/hooks/claims-filters.hooks.ts
import { create } from "zustand";
import * as React from "react";

// src/utils/filters-reducer.util.ts
import { cloneDeep, omit } from "lodash";
function isDateRangePayload(payload) {
  return payload.selectedDateRange !== void 0;
}
function filtersReducer(state, action) {
  switch (action.type) {
    case "toggle": {
      if (isDateRangePayload(action.payload)) {
        return state;
      }
      const newEntries = Object.entries(action.payload);
      const newState = cloneDeep(state);
      const timeAdded = Date.now();
      newEntries.forEach(([key, value]) => {
        var _a;
        const currentFilterValues = (_a = state.filters[key]) != null ? _a : [];
        const updatedFilterValues = [...currentFilterValues];
        const isFilterValueSelected = updatedFilterValues.find(
          (filterValue) => filterValue.value === value
        );
        if (isFilterValueSelected) {
          const valueIndex = updatedFilterValues.findIndex(
            (item) => item.value === value
          );
          updatedFilterValues.splice(valueIndex, 1);
        } else {
          const newFilter = { value, timestamp: timeAdded };
          updatedFilterValues.push(newFilter);
        }
        if (updatedFilterValues.length === 0) {
          newState.filters = omit(newState.filters, [key]);
        } else {
          Object.assign(newState.filters, { [key]: updatedFilterValues });
        }
      });
      return newState;
    }
    case "set-date": {
      const newState = cloneDeep(state);
      const timeAdded = Date.now();
      Object.assign(newState, __spreadProps(__spreadValues({}, action.payload), {
        selectedDateRangeTimestamp: timeAdded
      }));
      return newState;
    }
    case "clear": {
      const newState = cloneDeep(state);
      Object.assign(newState, {
        filters: {},
        selectedDateRange: void 0
      });
      return newState;
    }
    default:
      return state;
  }
}

// src/hooks/claims-filters.hooks.ts
var INITIAL_FILTERS = {
  filters: {},
  selectedDateRange: void 0,
  selectedDateRangeTimestamp: void 0
};
var useClaimsStore = create()((set) => __spreadProps(__spreadValues({}, INITIAL_FILTERS), {
  dispatch: (action) => set((state) => filtersReducer(state, action))
}));
function useClaimsFilters() {
  const filters = useClaimsStore((state) => state.filters);
  return filters;
}
function useSelectedDateRange() {
  const selectedDateRange = useClaimsStore((state) => state.selectedDateRange);
  return selectedDateRange;
}
function useSelectedDateRangeTimestamp() {
  const selectedDateRangeTimestamp = useClaimsStore(
    (state) => state.selectedDateRangeTimestamp
  );
  return selectedDateRangeTimestamp;
}
function useToggleClaimsFilter() {
  const dispatch = useClaimsStore((state) => state.dispatch);
  return React.useCallback(
    (filter) => {
      dispatch({
        type: "toggle",
        payload: filter
      });
    },
    [dispatch]
  );
}
function useDateRange() {
  const dispatch = useClaimsStore((state) => state.dispatch);
  return React.useCallback(
    (dateRange) => {
      dispatch({
        type: "set-date",
        payload: dateRange
      });
    },
    [dispatch]
  );
}
function useClearFilters() {
  const dispatch = useClaimsStore((state) => state.dispatch);
  return React.useCallback(() => dispatch({ type: "clear" }), [dispatch]);
}

// src/hooks/use-selected-filters.hook.ts
import * as React3 from "react";
import { create as create3 } from "zustand";

// src/hooks/pagination/use-pagination-store.hook.ts
import * as React2 from "react";
import { create as create2 } from "zustand";
var usePaginationStore = create2((set) => ({
  clearPagination: () => set((state) => __spreadProps(__spreadValues({}, state), { pagination: void 0, currentPage: 1 })),
  currentPage: 1,
  pagination: void 0,
  setCurrentPage: (pageNumber) => set(() => ({ currentPage: pageNumber })),
  setCursor: (cursor) => set(() => ({ cursor })),
  setLimit: (limit) => set(() => ({ limit })),
  setPagination: (pagination) => set(() => ({ pagination })),
  setTotalItems: (totalItems) => set(() => ({ totalItems }))
}));
var useSetPagination = () => {
  const setPagination = usePaginationStore((state) => state.setPagination);
  return React2.useCallback(
    (pagination) => setPagination(pagination),
    [setPagination]
  );
};
var useClearPagination = () => {
  const clearPagination = usePaginationStore((state) => state.clearPagination);
  return React2.useCallback(() => {
    clearPagination();
  }, [clearPagination]);
};
var usePaginationValue = () => {
  const pagination = usePaginationStore((state) => state.pagination);
  return pagination;
};
var useSetCurrentPagePagination = () => {
  const setCurrentPage = usePaginationStore((state) => state.setCurrentPage);
  return React2.useCallback(
    (pageNumber) => setCurrentPage(pageNumber),
    [setCurrentPage]
  );
};
var useSetLimitPagination = () => {
  const setLimit = usePaginationStore((state) => state.setLimit);
  return React2.useCallback((limit) => setLimit(limit), [setLimit]);
};
var useCurrentPagePagination = () => {
  const currentPage = usePaginationStore((state) => state.currentPage);
  return currentPage;
};
var useLimitPagination = () => {
  const limit = usePaginationStore((state) => state.limit);
  return limit;
};
var useTotalItemsPagination = () => {
  const totalItems = usePaginationStore((state) => state.totalItems);
  return totalItems;
};
var useSetTotalItemsPagination = () => {
  const setTotalItems = usePaginationStore((state) => state.setTotalItems);
  return React2.useCallback(
    (items) => setTotalItems(items),
    [setTotalItems]
  );
};
var useCursorPagination = () => {
  const cursorValues = usePaginationStore((state) => state.cursor);
  return cursorValues;
};
var useSetCursorPagination = () => {
  const setSetCursor = usePaginationStore((state) => state.setCursor);
  return React2.useCallback(
    (cursor) => setSetCursor(cursor),
    [setSetCursor]
  );
};

// src/hooks/use-selected-filters.hook.ts
var useSelectedFilterStore = create3(
  (set) => ({
    selectedFilters: [],
    addSelectedFilter: (filter) => set((state) => ({
      selectedFilters: [filter, ...state.selectedFilters]
    })),
    removeFilter: (filter) => set((state) => ({
      selectedFilters: state.selectedFilters.filter(
        (f) => f.key !== filter.key || f.value !== filter.value
      )
    })),
    clearAllFilters: () => set(() => ({
      selectedFilters: []
    }))
  })
);
var useSelectedFilters = () => {
  const selectedFilters = useSelectedFilterStore(
    (state) => state.selectedFilters
  );
  return selectedFilters;
};
var useAddSelectedFilter = () => {
  const addSelectedFilter = useSelectedFilterStore(
    (state) => state.addSelectedFilter
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filter) => {
      addSelectedFilter(filter);
      clearPagination();
    },
    [addSelectedFilter, clearPagination]
  );
};
var useRemoveSelectedFilter = () => {
  const removeSelectedFilter = useSelectedFilterStore(
    (state) => state.removeFilter
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filter) => {
      removeSelectedFilter(filter);
      clearPagination();
    },
    [clearPagination, removeSelectedFilter]
  );
};
var useClearAllFilters = () => {
  const clearAllFilters = useSelectedFilterStore(
    (state) => state.clearAllFilters
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(() => {
    clearAllFilters();
    clearPagination();
  }, [clearAllFilters, clearPagination]);
};

// src/hooks/use-allow-clear-filters.hook.ts
function useAllowClearFilters() {
  const filters = useClaimsFilters();
  const selectedDateRange = useSelectedDateRange();
  const validFilters = Object.entries(filters).filter(
    ([, value]) => value.length > 0
  );
  const allowClearFilters = !(selectedDateRange === void 0) || !(validFilters.length === 0);
  return allowClearFilters;
}

// src/utils/select-filtered-claims.util.ts
function selectFilteredClaims(claims, filterConfig) {
  const filterKeys = Object.keys(filterConfig);
  const validFilters = filterKeys.filter((key) => {
    const filterValue = filterConfig[key];
    return !!(filterValue == null ? void 0 : filterValue.length);
  });
  if (!(validFilters == null ? void 0 : validFilters.length)) {
    return claims;
  }
  return claims.filter(
    (claim) => validFilters.every((key) => {
      var _a;
      const filterValue = (_a = filterConfig[key]) != null ? _a : [];
      const formattedFilterValues = filterValue.flatMap(
        (filter) => filter.value
      );
      const claimValue = claim[key];
      if (formattedFilterValues.includes(claimValue)) {
        return true;
      }
      return false;
    })
  );
}

// src/hooks/use-is-first-load.hook.ts
import { GET_CLAIMS_SUMMARY_PATH } from "@leagueplatform/claims-api";
import { useQueryClient } from "react-query";
function useIsFirstLoad() {
  const queryClient = useQueryClient();
  const claimsData = queryClient.getQueriesData({
    queryKey: [GET_CLAIMS_SUMMARY_PATH]
  });
  return !claimsData.filter(([, data]) => !!data).length;
}

// src/hooks/use-search-claims-query-attributes.hook.ts
import * as React4 from "react";

// src/utils/format-claims-search-filters.util.ts
var formatClaimsSearchFilters = (selectedFilters) => selectedFilters.reduce(
  (previousValue, currentValue) => {
    const existingFilter = previousValue.find(
      (val) => val.key === currentValue.key
    );
    if (existingFilter) {
      existingFilter.values = [...existingFilter.values, currentValue.value];
    } else {
      previousValue.push({
        key: currentValue.key,
        values: [currentValue.value]
      });
    }
    return previousValue;
  },
  []
);

// src/hooks/use-search-claims-query-attributes.hook.ts
function useSearchClaimsQueryAttributes(selectedFilters) {
  const pagination = usePaginationValue();
  const filters = React4.useMemo(
    () => formatClaimsSearchFilters(selectedFilters),
    [selectedFilters]
  );
  const attributes = React4.useMemo(
    () => __spreadValues({
      filters
    }, pagination && { pagination }),
    [pagination, filters]
  );
  return attributes;
}

// src/hooks/pagination/use-pagination.hook.ts
import * as React7 from "react";

// src/hooks/pagination/use-offset-pagination.hook.ts
import * as React5 from "react";
function useOffsetPagination({
  isEnabled,
  onPageChangeCallback
}) {
  const [offset, setOffset] = React5.useState(0);
  const getOffset = React5.useCallback(
    (pageNumber, pageSize2 = 10) => (pageNumber - 1) * pageSize2,
    []
  );
  const setCurrentPage = useSetCurrentPagePagination();
  const pageSize = useLimitPagination();
  const totalItems = useTotalItemsPagination();
  const currentPage = useCurrentPagePagination();
  const totalPages = React5.useMemo(() => {
    if (!pageSize || !totalItems) {
      return void 0;
    }
    return Math.ceil(totalItems / pageSize);
  }, [pageSize, totalItems]);
  const handlePageChange = React5.useCallback(
    (newPage) => {
      setCurrentPage(newPage.pageNumber);
      const newOffset = getOffset(newPage.pageNumber, pageSize);
      setOffset(newOffset);
      onPageChangeCallback({
        offset: `${newOffset}`,
        pageSize: pageSize != null ? pageSize : 10
      });
    },
    [getOffset, onPageChangeCallback, pageSize, setCurrentPage]
  );
  if (!isEnabled) {
    return null;
  }
  return {
    currentPage,
    offset,
    onPageChange: handlePageChange,
    pageSize,
    totalPages
  };
}

// src/hooks/pagination/use-cursor-pagination.hook.ts
import * as React6 from "react";
function useCursorPagination2({
  isEnabled,
  onPageChangeCallback
}) {
  const setCurrentPage = useSetCurrentPagePagination();
  const pageSize = useLimitPagination();
  const currentPage = useCurrentPagePagination();
  const cursorValue = useCursorPagination();
  const handlePageChange = React6.useCallback(
    (newPage) => {
      var _a, _b;
      let cursor;
      let newPageNumber = 1;
      if (newPage.buttonType === "next") {
        newPageNumber = (currentPage != null ? currentPage : 1) + 1;
        setCurrentPage(newPageNumber);
        cursor = (_a = cursorValue == null ? void 0 : cursorValue.next) != null ? _a : void 0;
      } else if (newPage.buttonType === "previous") {
        newPageNumber = (currentPage != null ? currentPage : 1) - 1;
        setCurrentPage(newPageNumber);
        cursor = (_b = cursorValue == null ? void 0 : cursorValue.prev) != null ? _b : void 0;
      }
      onPageChangeCallback({
        cursor,
        pageSize: pageSize != null ? pageSize : 10
      });
    },
    [currentPage, onPageChangeCallback, pageSize, setCurrentPage, cursorValue]
  );
  if (!isEnabled) {
    return null;
  }
  return {
    currentPage: currentPage != null ? currentPage : 1,
    isNextButtonEnabled: !!(cursorValue == null ? void 0 : cursorValue.next),
    isPrevButtonEnabled: !!(cursorValue == null ? void 0 : cursorValue.prev),
    onPageChange: handlePageChange,
    pageSize
  };
}

// src/hooks/pagination/use-pagination.hook.ts
function usePagination() {
  const [initialized, setInitialized] = React7.useState(false);
  const [strategy, setStrategy] = React7.useState(
    null
  );
  const clearPagination = useClearPagination();
  const setPagination = useSetPagination();
  const setLimit = useSetLimitPagination();
  const setTotalItems = useSetTotalItemsPagination();
  const setCursor = useSetCursorPagination();
  const isOffsetPagination = strategy === "offset";
  const isCursorPagination = strategy === "cursor";
  const handlePageChange = React7.useCallback(
    (pagination) => {
      setPagination(pagination);
    },
    [setPagination]
  );
  const offsetPagination = useOffsetPagination({
    isEnabled: isOffsetPagination,
    onPageChangeCallback: handlePageChange
  });
  const cursorPagination = useCursorPagination2({
    isEnabled: isCursorPagination,
    onPageChangeCallback: handlePageChange
  });
  const initializePagination = React7.useCallback(
    ({
      strategy: initializedStrategy,
      limit: initializedLimit,
      totalItems: initializedTotalItems,
      next,
      prev
    }) => {
      setInitialized(true);
      setStrategy(initializedStrategy);
      setLimit(initializedLimit);
      setTotalItems(initializedTotalItems != null ? initializedTotalItems : 0);
      setCursor({ next, prev });
    },
    [setCursor, setLimit, setTotalItems]
  );
  if (initialized && isOffsetPagination) {
    return __spreadValues({
      clearPagination,
      initialized,
      initializePagination
    }, offsetPagination);
  }
  if (initialized && isCursorPagination) {
    return __spreadValues({
      clearPagination,
      initialized,
      initializePagination
    }, cursorPagination);
  }
  return {
    clearPagination,
    initialized,
    initializePagination
  };
}

// src/utils/select-start-end-date.util.ts
import { format, subDays } from "date-fns";
function selectStartEndDates(selectedDateRange) {
  const dateFormat = "yyyy-MM-dd";
  let endDate;
  let startDate;
  switch (selectedDateRange) {
    case "last_12_months": {
      endDate = format(/* @__PURE__ */ new Date(), dateFormat);
      startDate = format(
        new Date((/* @__PURE__ */ new Date()).setFullYear((/* @__PURE__ */ new Date()).getFullYear() - 1)),
        dateFormat
      );
      return { startDate, endDate };
    }
    case "year_to_date": {
      endDate = format(/* @__PURE__ */ new Date(), dateFormat);
      startDate = format(new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1), dateFormat);
      return { startDate, endDate };
    }
    case "prior_year": {
      const priorYear = (/* @__PURE__ */ new Date()).getFullYear() - 1;
      endDate = format(new Date(priorYear, 11, 31), dateFormat);
      startDate = format(new Date(priorYear, 0, 1), dateFormat);
      return { startDate, endDate };
    }
    case "90_days": {
      const currentDate = /* @__PURE__ */ new Date();
      endDate = format(currentDate, dateFormat);
      startDate = format(new Date(subDays(currentDate, 90)), dateFormat);
      return { startDate, endDate };
    }
    default:
      endDate = format(/* @__PURE__ */ new Date(), dateFormat);
      startDate = format(
        new Date((/* @__PURE__ */ new Date()).setFullYear((/* @__PURE__ */ new Date()).getFullYear() - 2)),
        dateFormat
      );
      return { startDate, endDate };
  }
}

// src/utils/get-configured-filters.util.ts
function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isFunction(value) {
  return typeof value === "function";
}
function getConfiguredFilters(claims, filterableProperties) {
  const filterEntries = Object.entries(filterableProperties);
  const configuredFilters = filterEntries.map(([filterType, filterValues]) => {
    var _a;
    let values = filterValues != null ? filterValues : [];
    let isVisible = true;
    if (filterValues === void 0) {
      return null;
    }
    if (isObject(filterValues)) {
      values = filterValues.options;
      if (isFunction(values)) {
        values = values(claims != null ? claims : []);
      }
      if (isFunction(filterValues.isVisible)) {
        isVisible = filterValues.isVisible(claims != null ? claims : [], values);
      } else {
        isVisible = (_a = filterValues.isVisible) != null ? _a : true;
      }
    }
    if (isFunction(values)) {
      values = values(claims != null ? claims : []);
    }
    return {
      filterType,
      filterValues: values,
      isVisible
    };
  }).filter((filter) => filter !== null && filter.isVisible);
  return configuredFilters;
}

// src/utils/create-dynamic-claim-property-filter-function.util.ts
function createDynamicClaimPropertyFilterFunction(prop) {
  return (claims) => [
    ...new Set(claims.map((claim) => claim[prop]))
  ];
}

// src/index.ts
initModule();
export {
  CLAIMS_MASONRY_STATUS_COLORS_MAP,
  CLAIMS_STATUS_COLORS_MAP,
  createDynamicClaimPropertyFilterFunction,
  formatClaimsSearchFilters,
  getConfiguredFilters,
  selectFilteredClaims,
  selectStartEndDates,
  useAddSelectedFilter,
  useAllowClearFilters,
  useClaimsFilters,
  useClearAllFilters,
  useClearFilters,
  useClearPagination,
  useDateRange,
  useDownloadExplanationOfBenefits,
  useFormatClaimsValue,
  useIsFirstLoad,
  usePagination,
  usePaginationValue,
  useRemoveSelectedFilter,
  useSearchClaimsQueryAttributes,
  useSelectedDateRange,
  useSelectedDateRangeTimestamp,
  useSelectedFilters,
  useToggleClaimsFilter
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/claims-common'] = window.leagueSDKsPresent['@leagueplatform/claims-common'] || [];
    window.leagueSDKsPresent['@leagueplatform/claims-common'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/claims-common'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/claims-common module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map